import angular from 'angular';
import '../services/displaytv';
import '../services/errors';
import '../services/display';
import '../services/globals';
import '../services/line';
import '../services/area';
import '../services/redirect-to-new-version';
import '../components/operator';
import '../components/status';
import '../directives/wlvideo';
import '../services/organization';
import { differenceBy, get, cloneDeep } from 'lodash';
import { Howl } from 'howler';
import { localStorage } from '../utils';

const module = angular.module('whyline.controllers.display-tv', [
  'whyline.services.displaytv',
  'whyline.services.errors',
  'whyline.services.display',
  'whyline.services.globals',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.redirect-to-new-version',
  'whyline.components.operator',
  'whyline.components.status',
  'whyline.directives.wlvideo',
  'whyline.services.organization'
]);

const DisplayTvController = (
  $scope,
  $sce,
  $rootScope,
  ErrorService,
  DisplayTvService,
  DisplayService,
  $interval,
  PlaceService,
  $state,
  $timeout,
  $log,
  Fullscreen,
  $window,
  RedirectToNewVersionService,
  $location,
  OrganizationService
) => {
  /*@ngInject*/

  let wsDisplay;

  $scope.place = {};
  $scope.organization = {};
  $scope.currentVideo = null;
  $scope.animationClass = 'green-flash';
  $scope.isMacro = true;
  $scope.iframeUrl = $sce.trustAsResourceUrl('http://eflowtest01/ste20/Node/NodeView.aspx?OrganizationCode=509&DTECode=509Ndo01&InstanceCode=509Ndo01&noredirect=true');


  PlaceService.GetOneAsPromiseFromServer($state.params.placeId).then((place) => {
    $scope.place = place;
    if ($scope.place.revertMigration) {
      RedirectToNewVersionService.Redirect(
        'display',
        place._id,
        localStorage.get('user')._id,
        $state.params.displayId,
      );
    }
    $scope.placeVideos = cloneDeep($scope.place.videos);
    $scope.videos = [...$scope.place.videos];
  });
  OrganizationService.GetCurrentAsPromise().then(organization => {
    $scope.organization = organization;
  })
  $scope.fontSize = $state.params.fontSize;
  $scope.data = [];
  $scope.toCall = [];
  $scope.listToShow = [];
  $scope.identify = false;
  $scope.socketIsDown = true;
  $scope.lastCalled = null;
  $scope.listLimit = 0;
  let counter = 0;
  const sound = new Howl({ src: ['https://dwpax42uzpe12.cloudfront.net/clear/sounds/dingdong.mp3'] });

  $rootScope.$on('socket:display-connected', (event, socket) => {
    wsDisplay = socket;

    $scope.socketIsDown = false;

    socket.emit('display:opened', $state.params.displayId);
  });

  $rootScope.$emit('display-tv:open-websocket-connection', { displayId: $state.params.displayId });

  const removeIfExists = (subscription, subscriptions) => {
    for (let index = subscriptions.length - 1; index >= 0; index--) {
      const item = subscriptions[index];
      const itemId = item._id || item.subscriptionId;
      if (itemId && (itemId === subscription._id || itemId === subscription.subscriptionId)) {
        subscriptions.splice(index, 1);
      }
    }
  };

  $rootScope.$on('display:recall-subscription', (event, data) => {
    removeIfExists(data, $scope.toCall);

    $scope.toCall.unshift(data);
  });

  $rootScope.$on('display:call-subscription', (event, data) => {
    removeIfExists(data, $scope.toCall);

    $scope.toCall.push(data);
  });

  $rootScope.$on('display:update-next-calls', (event, data) => {
    if (!data) {
      updateNextCalls();
    } else {
      removeIfExists(data, $scope.nextCalls);
    }
  });

  $rootScope.$on('display:ping', () => {
    try {
      if (wsDisplay) {
        wsDisplay.emit('display:pong', $state.params.displayId);
      }
    } catch (e) {
      console.error('display:ping', e);
    }
  });

  $rootScope.$on('display:identify', () => {
    $scope.identify = true;
    $interval(() => ($scope.identify = false), 5000);
  });

  $rootScope.$on('display:refresh', () => {
    $window.location.reload();
  });

  $rootScope.$on('display:minmax', () => { });

  $rootScope.$on('display:reconnected', () => {
    $scope.socketIsDown = false;
  });

  $rootScope.$on('display:disconnected', () => {
    $scope.socketIsDown = true;
  });

  //$rootScope.$emit('connect-display-socket');

  // Do this when display load first time
  DisplayService.GetOneAsPromise($state.params.displayId)
    .then((currentDisplay) => {
      $timeout(() => {
        // Putting the current display available on scope
        $scope.currentDisplay = currentDisplay;
        DisplayTvService.GetDisplayTvData($state.params.displayId).then((displayTvData) => {
          $timeout(() => {
            $scope.data = displayTvData;
            $scope.lastCalled = $scope.data.shift();
            const callQuantity = currentDisplay.callQuantity ? currentDisplay.callQuantity : 6;
            $scope.listLimit = callQuantity;
            let localListToShow = $scope.data;
            if (localListToShow.length < callQuantity) {
              for (let index = localListToShow.length; index < callQuantity; index++) {
                localListToShow.push({
                  alias: [],
                  called: { box: '' },
                  line: { label: '', supervisorLine: false },
                  subscriptionId: index,
                });
              }
            } else {
              localListToShow = $scope.data.slice(0, callQuantity);
            }
            $scope.listToShow = localListToShow;
          });
        });
      });
    })
    .catch(ErrorService.handler);

  const getNewData = () => {
    try {
      // Get subscriptions called
      DisplayTvService.GetDisplayTvData($state.params.displayId).then((displayTvData) => {
        $timeout(() => {
          $scope.toCall = differenceBy(displayTvData, $scope.data, 'subscriptionId');

          try {
            if ($scope.lastCalled) {
              removeIfExists($scope.lastCalled, $scope.toCall);
            }
          } catch (e) {
            console.error('getNewData - removeIfExists', e);
          }
        });
      });
    } catch (e) {
      console.error('getNewData', e);
    }
  };

  $scope.doAnimation = undefined;

  const callNext = () => {
    if ($scope.toCall.length) {
      const nextCall = $scope.toCall[0];
      if ($scope.lastCalled && nextCall.subscriptionId !== $scope.lastCalled.subscriptionId) {
        removeIfExists($scope.lastCalled, $scope.data);
        removeIfExists(nextCall, $scope.data);
        $scope.data.unshift($scope.lastCalled);
        $scope.listToShow = $scope.data.slice(0, $scope.listLimit);
      }

      $scope.doAnimation = new Date().getTime();

      $scope.lastCalled = $scope.toCall.shift();
      sound.play();
    }
  };

  $scope.pressForFullScreen = () => {
    if (counter < 3) {
      counter += 1;
    }
    if (counter === 3) {
      counter = 0;
      if (Fullscreen.isEnabled()) {
        Fullscreen.cancel();
      } else {
        Fullscreen.all();
      }
    }
  };

  $scope.stopCurrentDisplayRefresh = $interval(() => {
    PlaceService.GetOneAsPromiseFromServer($scope.place._id).then((res) => {
      $timeout(() => {
        const videosFromServer = get(res, 'videos', []);
        const brokenVideos = differenceBy($scope.placeVideos, $scope.videos, 'src');
        const newVideos = differenceBy(videosFromServer, brokenVideos, 'src');
        $scope.videos = newVideos;
        $scope.placeVideos = videosFromServer;
      });
    });
  }, 2 * 60 * 1000);

  const stopGettingNewData = $interval(() => {
    if ($scope.socketIsDown) {
      getNewData();
    }
  }, 5000);

  const checkIfHaveToCall = $interval(() => {
    callNext();
  }, 4000);

  $scope.$on('$destroy', () => {
    $rootScope.$emit('display-tv:close-websocket-connection', {});
    if (angular.isDefined(stopGettingNewData)) {
      $interval.cancel(stopGettingNewData);
    }
    if (angular.isDefined(checkIfHaveToCall)) {
      $interval.cancel(checkIfHaveToCall);
    }
    if (angular.isDefined(stopCurrentDisplayRefresh)) {
      $interval.cancel(stopCurrentDisplayRefresh);
    }
  });
};

module.exports = module.controller('DisplayTvController', DisplayTvController);
